import React from 'react';
import Loader from 'react-loaders';

export interface AppLoaderProps {}

export const AppLoader = (props: AppLoaderProps) => {
	return (
		<div className="loader-container">
			<div className="loader-container-inner">
				<div className="text-center">
					<Loader type="ball-scale-multiple" active />
				</div>
				<h6 className="mt-5">Loading your request...</h6>
			</div>
		</div>
	);
};
